export interface OralSupplementsType {
  barcode: string,
  dilutionDescription: string,
  dosePrescriptionQuantity: number,
  doseQuantity: number,
  groupingNumber: number,
  intervalCode: string,
  materialCode: number,
  materialDescription: string,
  materialHighRisk: string,
  materialObservation: string,
  materialSequence: number,
  prescriptionNumber: number,
  processCode: number,
  routeAdministrationDescription: string,
  scheduleDate: string,
  statusItem: string,
  unitMeasureDoseCode: string,
  unitMeasureDoseDescription: string
}

export enum PrescriptionPosition {
  LEFT = 'LEFT',
  RIGHT = 'RIGTH'
}